(function () {
  window.addEventListener('DOMContentLoaded', () => {
    const activeSubmenuLink = document.querySelector('.collectionSubcategories__listItem--active'),
          subcategoriesList = document.querySelector('.collectionSubcategories__list');

    if (subcategoriesList && activeSubmenuLink) {
      let leftPosition = activeSubmenuLink.offsetLeft;

      if (window.innerWidth <= 640 ) {
        leftPosition -= 24;
      } else {
        leftPosition -= 32;
      }

      subcategoriesList.scrollLeft = leftPosition;
    }
  })
})();